import { useQuery } from 'react-query';
import { axiosRequestHandler } from 'helpers/Requests';
import { IConciergeEmbedChatData } from 'interfaces/concierge';

export function useConciergeEmbedChatData(queryKey: string) {
  return useQuery<IConciergeEmbedChatData, Error>(
    queryKey,
    async () => {
      const response = await axiosRequestHandler(queryKey, false, true);
      return response.data as IConciergeEmbedChatData;
    },
    {
      staleTime: Infinity,
      retry: false,
    }
  );
}
